import Jwt from '@/model/Jwt';

class JwtService {
  LOCAL_STORAGE_KEY = 'docutax.jwt'

  get() {
    const result = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);

    if (!result) {
      return undefined;
    }

    const jwt = new Jwt(JSON.parse(result));

    if (!jwt.validate()) {
      console.warn('jwt is invalid', jwt);
      this.reset();
      return undefined;
    }

    return jwt;
  }

  set(jwt) {
    window.localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(jwt));
  }

  reset() {
    window.localStorage.removeItem(this.LOCAL_STORAGE_KEY);
  }
}

export default new JwtService();
